import React from 'react';
import { Link } from 'react-router-dom';
import { Spring, animated } from 'react-spring';

import styles from './style.css';

const AnimatedLink = animated(Link);

const Header = ({
  style: { logo, text, button, buttonHover } = {},
  hovered,
  handleMouseEnter,
  handleMouseLeave,
  handleMouseClick
}) => (
  <header className={styles.header}>
    <Link aria-label="Home" className={styles.header__logo} to="/">
      <Spring native to={logo}>
        {computedStyle => (
          <animated.svg
            style={computedStyle}
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 122 95"
          >
            <path
              fillRule="evenodd"
              d="M12.696 23.241l4.41-13.498 4.44 13.498h6.17L34.243 0h-6.378L24.11 13.825 19.759 0h-5.305l-4.351 13.855L6.348 0H0l6.527 23.241h6.169zM42.856 0H54.21c5.96 0 8.702 3.874 8.702 8.492 0 3.248-1.46 6.287-4.59 7.717l5.037 7.032h-7.122l-4.411-6.227h-3.04v6.227h-5.93V0zm11.026 5.423h-5.096v6.198h5.096c2.384 0 3.278-1.46 3.278-3.07 0-1.787-.894-3.128-3.278-3.128zM71.945 23.24h5.96v-7l1.58-1.758 6.407 8.76h7.39l-9.655-13.26L92.807 0h-7.69l-7.212 8.015V0h-5.96v23.241zM42.792 58.62V35.377h10.252c6.17 0 9.12 4.231 9.12 8.91 0 4.916-2.95 9.057-9.12 9.057h-4.291v5.274h-5.96zm9.925-17.82h-3.964v7.121h3.964c2.503 0 3.427-1.55 3.427-3.605 0-1.847-.924-3.516-3.427-3.516zm19.437-5.423h11.354c5.96 0 8.703 3.874 8.703 8.492 0 3.248-1.46 6.287-4.59 7.717l5.037 7.032h-7.123l-4.41-6.227h-3.04v6.227h-5.931V35.38zM82.34 40.8h-5.096v6.198h5.096c2.384 0 3.278-1.46 3.278-3.07 0-1.787-.894-3.128-3.278-3.128zm28.439 9.207h5.632v.656c-1.102 1.609-2.89 2.651-4.976 2.651A6.283 6.283 0 0 1 105.116 47a6.283 6.283 0 0 1 6.319-6.317 6.32 6.32 0 0 1 4.976 2.384l4.858-3.278c-2.235-2.92-5.841-4.857-9.834-4.857-6.736 0-12.339 5.423-12.339 12.068 0 6.644 5.603 12.067 12.339 12.067 2.384 0 4.738-.894 5.87-2.622v2.175h4.68V45.062h-11.206v4.946zm-98.344 8.601v-12.96l10.371 12.96h5.037v-23.24h-5.93v12.99L11.54 35.369H6.475v23.24zm30.357 12.137h11.355c5.96 0 8.702 3.874 8.702 8.492 0 3.248-1.46 6.287-4.59 7.718l5.037 7.032h-7.122l-4.411-6.228h-3.04v6.228h-5.93V70.745zm11.027 5.423h-5.096v6.198h5.096c2.384 0 3.278-1.46 3.278-3.069 0-1.788-.894-3.129-3.278-3.129zm19.095 10.846v.268c0 4.56 4.292 7.151 9.865 7.151 5.304 0 9.238-2.383 9.238-6.912 0-5.095-5.483-7.002-8.702-8.135-2.772-.953-3.845-1.43-3.845-2.354 0-.774.805-1.579 2.832-1.579 2.414 0 3.576 1.341 3.576 2.473v.209h5.811v-.328c0-4.618-4.083-7.508-9.507-7.508-5.304 0-9.09 2.77-9.09 7.21 0 4.797 4.859 6.585 8.554 7.807 2.801.953 3.964 1.55 3.964 2.533 0 .685-.716 1.43-2.95 1.43-2.713 0-3.935-1.222-3.935-2.116v-.149h-5.811zm28.324 0v.268c0 4.56 4.291 7.151 9.864 7.151 5.305 0 9.239-2.383 9.239-6.912 0-5.095-5.484-7.002-8.702-8.135-2.772-.953-3.845-1.43-3.845-2.354 0-.774.805-1.579 2.831-1.579 2.414 0 3.577 1.341 3.577 2.473v.209h5.811v-.328c0-4.618-4.083-7.508-9.507-7.508-5.305 0-9.09 2.77-9.09 7.21 0 4.797 4.858 6.585 8.554 7.807 2.801.953 3.963 1.55 3.963 2.533 0 .685-.715 1.43-2.95 1.43-2.712 0-3.934-1.222-3.934-2.116v-.149h-5.811z"
            />
          </animated.svg>
        )}
      </Spring>
    </Link>
    <div className={styles.header__content}>
      <Spring native to={text}>
        {computedStyle => (
          <animated.div
            className={styles.header__content__text}
            style={computedStyle}
          >
            let&#39;s create something amazing
          </animated.div>
        )}
      </Spring>
      <Spring native to={hovered ? buttonHover : button}>
        {computedStyle => (
          <AnimatedLink
            className={styles.header__content__button}
            style={computedStyle}
            to="/contact"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleMouseClick}
          >
            start a project
          </AnimatedLink>
        )}
      </Spring>
    </div>
  </header>
);

export default Header;
